/**
 * Gets the location of the current user's IP address.
 */
export default async function getIpLocation(ip?: string) {
  const publicIp = ip == null ? undefined : ['::1', '127.0.0.1', '::ffff:127.0.0.1'].includes(ip) ? undefined : ip;
  const { latitude: lat, longitude: lng } = (await fetch(
    publicIp ? `https://ipapi.co/${publicIp}/json` : 'https://ipapi.co/json'
  )
    .then(resp => resp.json())
    .catch(() =>
      Promise.reject(new Error('Could not get IP location. Sometimes this can be caused by ad-blockers.'))
    )) as {
    latitude: number;
    longitude: number;
  };
  return { lat, lng };
}
